/**
 * Engine preset configurations for tile size, spacing, and margin.
 * Used by NewMapDialog to auto-fill settings when a target engine is selected.
 */
export const ENGINE_PRESETS = {
  custom: {
    label: 'Custom',
    tileSizes: [],
    defaultTileSize: null,
    spacing: 0,
    margin: 0,
    notes: '',
  },
  godot4: {
    label: 'Godot 4',
    tileSizes: [16, 32],
    defaultTileSize: 16,
    spacing: 0,
    margin: 0,
    notes: 'Import TMJ via Tiled Map Importer addon. TileMap node uses TileSet resource.',
  },
  unity: {
    label: 'Unity',
    tileSizes: [16, 32],
    defaultTileSize: 16,
    spacing: 0,
    margin: 0,
    notes: 'Use SuperTiled2Unity to import. Set Pixels Per Unit (PPU) to match tile size in sprite import settings.',
  },
  phaser3: {
    label: 'Phaser 3',
    tileSizes: [16, 32],
    defaultTileSize: 32,
    spacing: 0,
    margin: 0,
    notes: 'Load with this.load.tilemapTiledJSON(). Supports TMJ natively.',
  },
  rpgmakerMZ: {
    label: 'RPG Maker MZ',
    tileSizes: [48],
    defaultTileSize: 48,
    spacing: 0,
    margin: 0,
    notes: 'RPG Maker MZ uses fixed 48x48 tiles. Tileset images must follow RPG Maker sheet layout.',
  },
  gamemaker: {
    label: 'GameMaker',
    tileSizes: [16, 32],
    defaultTileSize: 16,
    spacing: 0,
    margin: 0,
    notes: 'GameMaker supports configurable spacing. Import TMJ via extensions or manual parsing.',
  },
  defold: {
    label: 'Defold',
    tileSizes: [16, 32],
    defaultTileSize: 16,
    spacing: 0,
    margin: 0,
    notes: 'Defold supports margin, spacing, and inner padding on tile sources. Use Tiled extension for import.',
  },
  love2d: {
    label: 'Love2D',
    tileSizes: [16, 32],
    defaultTileSize: 16,
    spacing: 0,
    margin: 0,
    notes: 'Use STI (Simple Tiled Implementation) library for TMJ loading.',
  },
  pygame: {
    label: 'Pygame',
    tileSizes: [16, 32],
    defaultTileSize: 32,
    spacing: 0,
    margin: 0,
    notes: 'Use pytmx or pyscroll libraries for TMJ/TMX loading.',
  },
};
